import { render, staticRenderFns } from "./HeadingBlock.vue?vue&type=template&id=47e93f2a&scoped=true"
import script from "./HeadingBlock.vue?vue&type=script&lang=js"
export * from "./HeadingBlock.vue?vue&type=script&lang=js"
import style0 from "./HeadingBlock.vue?vue&type=style&index=0&id=47e93f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e93f2a",
  null
  
)

export default component.exports